import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import EntitySidebar from 'components/EntitySidebar';

import { CountrySidebar_country$key } from '__generated__/CountrySidebar_country.graphql';

type Props = {
  country: CountrySidebar_country$key;
};

const CountrySidebar: FC<Props> = props => {
  const country = useFragment(
    graphql`
      fragment CountrySidebar_country on Country {
        ...EntitySidebar_entity
      }
    `,
    props.country
  );

  return <EntitySidebar entity={country} />;
};

export default CountrySidebar;
